export const colors = {
  orange: '#ff8b01',
  red: 'red',
  darkOrange: '#fb7310',
  white: 'white',
  veryLightGray: '#f5f5f5',
  lightGray: '#d8d8d8',
  gray: '#e3e5e6',
  darkGray: '#646464',
  facebookBlue: '#4267b2',
  appleBlack: '#2b2b2b'
}

export const defaultTheme = {
  colors: colors,
  buttonTextColorPrimary: colors.white,
  buttonTextColorSecondary: colors.orange,
  buttonColorPrimary: colors.orange,
  buttonColorPrimaryHover: colors.darkOrange,
  buttonColorPrimaryDisabled: colors.lightGray,
  buttonColorPrimaryActive: colors.darkOrange,
  buttonColorSecondary: colors.white,
  buttonColorSecondaryHover: colors.veryLightGray,
  buttonColorSecondaryDisabled: colors.white,
  buttonColorSecondaryPressed: colors.darkGray,
  buttonColorSecondaryActive: colors.gray,
  textColorPrimary: colors.darkGray,
  fontFamily: 'proxima-nova',
  fontSizeExtraExtraSmall: '13px',
  fontSizeExtraSmall: '14px',
  fontSizeSmall: '16px',
  fontSizeMedium: '18px',
  fontSizeLarge: '22px'
}
